import React, { useState, useEffect, useCallback } from "react";
import { Box, Select, MenuItem } from "@mui/material";
import {useSelector} from "react-redux"
import api from "../../../API";
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import TzaListPage from "./TzaListPage"

const TzaWorkerPage = (props:any) => {

  // const dispatch = useDispatch();

  // const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  // let manager_role = auth.user.roles.some((obj:any) => ['TZA'].includes(obj.role));

  const worker = auth.user.roles.filter((obj:any) => obj.role === 'TZA').map((info:any) => info.user_id)[0];   
  
  const [work_yn, setWork_yn] = useState("모두");

  const [workList, setWorkList] = useState([]);

  const [page, setPage] = useState(1);
  
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [backdrop, setBackdrop] = useState<boolean>(false)

  const swWorkList = useCallback(async (work_yn:string) => {
    
    setBackdrop(true)
    api.get('/sw-workList',{params:{email:email,page:page,worker:worker,work_yn:work_yn,gub:"prc"}})
    .then((res:any) => {
      
      if(res.data.datas.length > 0){
        setWorkList(res.data);
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        setWorkList(res.data);
        setTotal_cnt(0)
      }
      setBackdrop(false)
      })
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
  },[email, page, worker])

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  useEffect(() => {
    // getAuth()
    swWorkList(work_yn)
  },[page, work_yn, swWorkList])

  return (
    <Box>
      {backdrop && ( <SearchBackDrop/> )}
      {/* 상단 메뉴 */}
      <Box display="flex" sx={{padding:"4px 8px 8px 8px"}}>
        <Box display="flex">
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px",alignSelf: "center"}}>작업할당 목록 (<b style={{color:"#1976d2"}}>{total_cnt !== 0 ? total_cnt:0}</b> 건)</Box>
        </Box>
        <Box display="flex" sx={{alignItems: "center", justifyContent: "right"}}>
          <Box sx={{marginLeft: "16px", fontSize:"16px"}}>작업상태</Box>
          <Select id="work_yn" value={work_yn} onChange={(e)=> { setWork_yn(e.target.value); swWorkList(e.target.value);}} sx={{width:"128px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            <MenuItem dense value={"None"}>미작업</MenuItem>
            <MenuItem dense value={"Y"}>작업완료</MenuItem>
          </Select>
        </Box>
        {/* <Box display="flex" sx={{marginLeft: "16px",alignItems: "center", justifyContent: "right"}}>
          <Box sx={{marginLeft: "16px", fontSize:"16px"}}>USE_CHECK</Box>
          <Select id="use_check" value={use_check} onChange={(e)=> { setUse_check(e.target.value); swWorkList(work_yn,e.target.value,task);}} sx={{width:"128px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            <MenuItem dense value={"T"}>사용가능</MenuItem>
            <MenuItem dense value={"C"}>내용수정</MenuItem>
            <MenuItem dense value={"F"}>사용불가</MenuItem>
            <MenuItem dense value={"None"}>미분류</MenuItem>
          </Select>
        </Box> */}
      </Box>
      {/* 상단 메뉴 */}

      {/* Task 단위 화면 */}
      <TzaListPage work_yn={work_yn} setPage={setPage} goPage={goPage} workList={workList} swWorkList={swWorkList}/>
      {/* Task 단위 화면 */}
    </Box>
  );
};

export default TzaWorkerPage;
